module.exports = __webpack_public_path__ + "static/media/car-police-policeman-svgrepo-com.86e4816c.svg";